import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from './assets/eagle_logo.png';
import enFlag from './assets/en.png';
import ruFlag from './assets/ru.png';
import plFlag from './assets/pl.png';
import { FaLock, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [shrink, setShrink] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [gamesOpen, setGamesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShrink(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setMenuActive(!menuActive);
  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    setLangOpen(false);
  };

  const currentFlag = i18n.language === 'ru' ? ruFlag : 
                     i18n.language === 'pl' ? plFlag : enFlag;
  const currentLabel = i18n.language === 'ru' ? 'РУС' : 
                      i18n.language === 'pl' ? 'POL' : 'ENG';

  return (
    <nav className={`navbar ${shrink ? 'shrink' : ''}`}>
      <div className="navbar-header">
        <div className="navbar-left">
          <a href="/" className="navbar-logo-link">
            <img src={logo} alt="EAGLE SCRIPT - Rust No Recoil Script Logo" className="navbar-logo" />
          </a>
        </div>

        {/* Mobile-only Language Switcher */}
        <div className="mobile-lang-switcher">
          <div className="lang-switcher">
            <button className="lang-button" onClick={() => setLangOpen(!langOpen)}>
              <img src={currentFlag} alt={currentLabel} />
              <span>{currentLabel}</span>
              {langOpen ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {langOpen && (
              <ul className="lang-dropdown">
                <li className="lang-item" onClick={() => changeLang('en')}>
                  <img src={enFlag} alt="EN" />
                  <span>ENG</span>
                </li>
                <li className="lang-item" onClick={() => changeLang('ru')}>
                  <img src={ruFlag} alt="РУС" />
                  <span>РУС</span>
                </li>
                <li className="lang-item" onClick={() => changeLang('pl')}>
                  <img src={plFlag} alt="POL" />
                  <span>POL</span>
                </li>
              </ul>
            )}
          </div>
        </div>

        <div className="navbar-hamburger" onClick={toggleMenu}>
          <span></span><span></span><span></span>
        </div>
      </div>

      <div className={`navbar-content ${menuActive ? 'active' : ''}`}>
        <ul className="navbar-menu">
          <li>
            <a href="/" onClick={() => setMenuActive(false)}>
              {t('home')}
            </a>
          </li>
          <li>
            <a href="#features" onClick={() => setMenuActive(false)}>
              {t('features')}
            </a>
          </li>
          <li>
            <a href="#reviews" onClick={() => setMenuActive(false)}>
              {t('reviews')}
            </a>
          </li>
          <li>
            <a href="#pricing" onClick={() => setMenuActive(false)}>
              {t('pricing')}
            </a>
          </li>
          <li className="games-dropdown-container">
            <button 
              className="games-dropdown-button" 
              onClick={() => setGamesOpen(!gamesOpen)}
            >
              Other Games {gamesOpen ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {gamesOpen && (
              <ul className="games-dropdown">
                <li>
                  <a 
                    href="/apex" 
                    onClick={() => {
                      setGamesOpen(false);
                      setMenuActive(false);
                    }}
                  >
                    Apex Legends
                  </a>
                </li>
              </ul>
            )}
          </li>
        </ul>
        <div className="navbar-right">
          <div className="lang-switcher">
            <button className="lang-button" onClick={() => setLangOpen(!langOpen)}>
              <img src={currentFlag} alt={currentLabel} />
              <span>{currentLabel}</span>
              {langOpen ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {langOpen && (
              <ul className="lang-dropdown">
                <li className="lang-item" onClick={() => changeLang('en')}>
                  <img src={enFlag} alt="English" />
                  <span>ENG</span>
                </li>
                <li className="lang-item" onClick={() => changeLang('ru')}>
                  <img src={ruFlag} alt="Русский" />
                  <span>РУС</span>
                </li>
                <li className="lang-item" onClick={() => changeLang('pl')}>
                  <img src={plFlag} alt="Polski" />
                  <span>POL</span>
                </li>
              </ul>
            )}
          </div>

          <a href="/private-login" className="private-login-link" onClick={() => setMenuActive(false)}>
            <FaLock className="lock-icon" />
            <span className="login-text">{t('private_login')}</span> {/* übersetzbar */}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
